import type { TrafficSignalNode } from './santa-coloma';
import type { IntersectionDefinition } from '../types/intersection';
import { ColorCode as CC } from '../types/intersection';

export const GUADALAJARA_CENTER: [number, number] = [-3.1684, 40.6369];
export const GUADALAJARA_BOUNDS: [[number, number], [number, number]] = [
  [-3.23, 40.60],
  [-3.12, 40.67]
];
export const GUADALAJARA_ZOOM = 15;

// All 34 OSM traffic signal nodes in Guadalajara
const allSignals: TrafficSignalNode[] = [
  { "id": 862230594, "position": [-3.1640175, 40.6306331], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 940811771, "position": [-3.172182, 40.6355938], "tags": {"crossing": "traffic_signals", "highway": "traffic_signals"} },
  { "id": 940811772, "position": [-3.1724464, 40.6350604], "tags": {"crossing": "traffic_signals", "highway": "traffic_signals"} },
  { "id": 940811774, "position": [-3.1715852, 40.634972], "tags": {"button_operated": "no", "crossing": "traffic_signals", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "no", "traffic_signals:vibration": "no"} },
  { "id": 940811777, "position": [-3.1723741, 40.6349863], "tags": {"crossing": "traffic_signals", "highway": "traffic_signals"} },
  { "id": 940811784, "position": [-3.1715226, 40.6354052], "tags": {"button_operated": "no", "crossing": "traffic_signals", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "no", "traffic_signals:vibration": "no"} },
  { "id": 940811790, "position": [-3.1723372, 40.6355196], "tags": {"crossing": "traffic_signals", "highway": "traffic_signals"} },
  { "id": 1348214711, "position": [-3.1644095, 40.6300964], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 1477243393, "position": [-3.1715595, 40.6354618], "tags": {"button_operated": "no", "crossing": "traffic_signals", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "no", "traffic_signals:vibration": "no"} },
  { "id": 1623706072, "position": [-3.1575202, 40.6329878], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 1636603350, "position": [-3.1577109, 40.6345575], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 1770935786, "position": [-3.1790454, 40.629974], "tags": {"button_operated": "no", "crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 1770935787, "position": [-3.1791669, 40.6300366], "tags": {"button_operated": "no", "crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 1770935794, "position": [-3.1792507, 40.6305187], "tags": {"button_operated": "no", "crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "yes", "traffic_signals:vibration": "no"} },
  { "id": 1770935795, "position": [-3.1791644, 40.6305782], "tags": {"button_operated": "no", "crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "yes", "traffic_signals:vibration": "no"} },
  { "id": 1799085198, "position": [-3.1716788, 40.6349303], "tags": {"button_operated": "no", "crossing": "traffic_signals", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals:sound": "no", "traffic_signals:vibration": "no"} },
  { "id": 1799085200, "position": [-3.1721123, 40.6352331], "tags": {"crossing": "no", "highway": "traffic_signals"} },
  { "id": 1799085201, "position": [-3.1717443, 40.6352367], "tags": {"crossing": "no", "highway": "traffic_signals"} },
  { "id": 1799085202, "position": [-3.1722254, 40.6352548], "tags": {"crossing": "no", "highway": "traffic_signals"} },
  { "id": 1799085203, "position": [-3.171842, 40.6352584], "tags": {"crossing": "no", "highway": "traffic_signals"} },
  { "id": 1840387379, "position": [-3.1725224, 40.6359371], "tags": {"highway": "traffic_signals"} },
  { "id": 2208503895, "position": [-3.1754802, 40.6327989], "tags": {"button_operated": "no", "crossing:markings": "zebra", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals": "traffic_lights", "traffic_signals:direction": "backward", "traffic_signals:sound": "yes", "traffic_signals:vibration": "no"} },
  { "id": 2208503897, "position": [-3.1755772, 40.6328743], "tags": {"button_operated": "no", "crossing:markings": "zebra", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals": "traffic_lights", "traffic_signals:direction": "backward", "traffic_signals:sound": "yes", "traffic_signals:vibration": "no"} },
  { "id": 2208503909, "position": [-3.1747044, 40.6333516], "tags": {"highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals": "traffic_lights", "traffic_signals:direction": "backward"} },
  { "id": 2208503917, "position": [-3.1748, 40.6334311], "tags": {"button_operated": "no", "highway": "traffic_signals", "tactile_paving": "yes", "traffic_signals": "traffic_lights", "traffic_signals:direction": "backward", "traffic_signals:sound": "yes", "traffic_signals:vibration": "no"} },
  { "id": 2284411011, "position": [-3.1648166, 40.6303261], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 2371041436, "position": [-3.1647474, 40.6301909], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 2371041437, "position": [-3.1643449, 40.6304974], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 2371065174, "position": [-3.1581171, 40.6341215], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 2371132785, "position": [-3.1785202, 40.6302052], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 2371132799, "position": [-3.178693, 40.6300576], "tags": {"crossing": "traffic_signals", "crossing:markings": "zebra", "highway": "traffic_signals"} },
  { "id": 3030695870, "position": [-3.1771033, 40.6317917], "tags": {"highway": "traffic_signals"} },
  { "id": 3030695871, "position": [-3.1770448, 40.6316697], "tags": {"highway": "traffic_signals"} },
  { "id": 13591205972, "position": [-3.178666, 40.6437938], "tags": {"highway": "traffic_signals", "traffic_signals": "signal", "traffic_signals:direction": "backward"} },
];

// IDs of signals used as regulator groups (simulated intersections)
const INTERSECTION_SIGNAL_IDS = new Set([
  // R2001 — Plaza Mayor (8)
  1799085200, 1799085202, 1799085201, 1799085203,
  940811774, 940811784, 940811772, 940811771,
  // R2002 — Av. del Ejército (4)
  2208503895, 2208503897, 2208503909, 2208503917,
  // R2003 — Glorieta Boixareu (6)
  1770935786, 1770935787, 1770935794, 1770935795, 2371132785, 2371132799,
  // R2004 — C/ del Trabajo (5)
  862230594, 1348214711, 2284411011, 2371041436, 2371041437,
]);

// Static signals (34 - 23 = 11 not assigned to any regulator)
export const guadalajaraStaticSignals: TrafficSignalNode[] =
  allSignals.filter(s => !INTERSECTION_SIGNAL_IDS.has(s.id));

// Keep full list exported for compatibility
export const guadalajaraSignals = allSignals;

// Empty geometry stub (reused by all Guadalajara intersections)
const EMPTY_GEOMETRY: IntersectionDefinition['geometry'] = {
  lanes: [],
  crosswalks: [],
  intersectionArea: {
    type: 'Feature',
    properties: { id: 'area' },
    geometry: { type: 'Polygon', coordinates: [[]] },
  },
};

// =============================================================================
// R2001 — Plaza Mayor (8 groups: 4V + 4P)
// Fase A: E-W verde, N-S rojo
// =============================================================================
const plazaMayor: IntersectionDefinition = {
  id: 'guadalajara-plaza-mayor',
  name: 'Plaza Mayor',
  center: [-3.1720, 40.6352],
  zoom: 18.5, bearing: 0, pitch: 50,
  cabinet: { position: [-3.1720, 40.6352], logicalId: 2001, physicalId: 'H0-C1-R1-S0' },
  groups: [
    { id: 1, type: 'V', label: 'G1 · E-W', position: [-3.1721123, 40.6352331], bearing: 90,
      phaseColors: { A: CC.V, B: CC.A, C: CC.R, D: CC.R } },
    { id: 2, type: 'V', label: 'G2 · W-E', position: [-3.1722254, 40.6352548], bearing: 270,
      phaseColors: { A: CC.V, B: CC.A, C: CC.R, D: CC.R } },
    { id: 3, type: 'V', label: 'G3 · N-S', position: [-3.1717443, 40.6352367], bearing: 180,
      phaseColors: { A: CC.R, B: CC.R, C: CC.V, D: CC.A } },
    { id: 4, type: 'V', label: 'G4 · S-N', position: [-3.171842, 40.6352584], bearing: 0,
      phaseColors: { A: CC.R, B: CC.R, C: CC.V, D: CC.A } },
    { id: 5, type: 'P', label: 'G5 · Peat. E-W', position: [-3.1715852, 40.634972], bearing: 90,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    { id: 6, type: 'P', label: 'G6 · Peat. E-W', position: [-3.1715226, 40.6354052], bearing: 90,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    { id: 7, type: 'P', label: 'G7 · Peat. N-S', position: [-3.1724464, 40.6350604], bearing: 0,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
    { id: 8, type: 'P', label: 'G8 · Peat. N-S', position: [-3.172182, 40.6355938], bearing: 0,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
  ],
  detectors: [],
  geometry: EMPTY_GEOMETRY,
};

// =============================================================================
// R2002 — Av. del Ejército / C. Calderón de la Barca (4 groups: 4V)
// Fase A: N-S verde, E-W rojo (opposite to Plaza Mayor)
// =============================================================================
const avEjercito: IntersectionDefinition = {
  id: 'guadalajara-av-ejercito',
  name: 'Av. del Ejército',
  center: [-3.1751, 40.6331],
  zoom: 18.5, bearing: 0, pitch: 50,
  cabinet: { position: [-3.1751, 40.6331], logicalId: 2002, physicalId: 'H0-C1-R2-S0' },
  groups: [
    // Par sur — eje E-W
    { id: 1, type: 'V', label: 'G1 · S-W', position: [-3.1754802, 40.6327989], bearing: 0,
      phaseColors: { A: CC.R, B: CC.R, C: CC.V, D: CC.A } },
    { id: 2, type: 'V', label: 'G2 · S-E', position: [-3.1755772, 40.6328743], bearing: 180,
      phaseColors: { A: CC.R, B: CC.R, C: CC.V, D: CC.A } },
    // Par norte — eje N-S
    { id: 3, type: 'V', label: 'G3 · N-W', position: [-3.1747044, 40.6333516], bearing: 270,
      phaseColors: { A: CC.V, B: CC.A, C: CC.R, D: CC.R } },
    { id: 4, type: 'V', label: 'G4 · N-E', position: [-3.1748, 40.6334311], bearing: 90,
      phaseColors: { A: CC.V, B: CC.A, C: CC.R, D: CC.R } },
  ],
  detectors: [],
  geometry: EMPTY_GEOMETRY,
};

// =============================================================================
// R2003 — Glorieta Capitán Boixareu Rivera (6 groups: 6P)
// 3 pares peatonales en rotonda. Fase A: par sur+este verdes. Fase C: par norte verde.
// =============================================================================
const glorietaBoixareu: IntersectionDefinition = {
  id: 'guadalajara-glorieta-boixareu',
  name: 'Glorieta Boixareu',
  center: [-3.1790, 40.6302],
  zoom: 18.5, bearing: 0, pitch: 50,
  cabinet: { position: [-3.1790, 40.6302], logicalId: 2003, physicalId: 'H0-C1-R3-S0' },
  groups: [
    // Par sur
    { id: 1, type: 'P', label: 'G1 · Peat. S-W', position: [-3.1790454, 40.629974], bearing: 270,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    { id: 2, type: 'P', label: 'G2 · Peat. S-E', position: [-3.1791669, 40.6300366], bearing: 90,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    // Par norte
    { id: 3, type: 'P', label: 'G3 · Peat. N-W', position: [-3.1792507, 40.6305187], bearing: 270,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
    { id: 4, type: 'P', label: 'G4 · Peat. N-E', position: [-3.1791644, 40.6305782], bearing: 90,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
    // Par este
    { id: 5, type: 'P', label: 'G5 · Peat. E-N', position: [-3.1785202, 40.6302052], bearing: 0,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    { id: 6, type: 'P', label: 'G6 · Peat. E-S', position: [-3.178693, 40.6300576], bearing: 180,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
  ],
  detectors: [],
  geometry: EMPTY_GEOMETRY,
};

// =============================================================================
// R2004 — C/ del Trabajo / San Roque (5 groups: 5P)
// Cruce compacto, 2 pares + 1 extra. Fase A: par norte verde. Fase C: par sur verde.
// =============================================================================
const calleDelTrabajo: IntersectionDefinition = {
  id: 'guadalajara-calle-trabajo',
  name: 'C/ del Trabajo',
  center: [-3.1645, 40.6303],
  zoom: 18.5, bearing: 0, pitch: 50,
  cabinet: { position: [-3.1645, 40.6303], logicalId: 2004, physicalId: 'H0-C1-R4-S0' },
  groups: [
    // Par norte (lat ~40.6305-40.6306)
    { id: 1, type: 'P', label: 'G1 · Peat. NW', position: [-3.1640175, 40.6306331], bearing: 270,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    { id: 2, type: 'P', label: 'G2 · Peat. NE', position: [-3.1643449, 40.6304974], bearing: 90,
      phaseColors: { A: CC.P, B: CC.I, C: CC.H, D: CC.H } },
    // Par sur (lat ~40.6301-40.6302)
    { id: 3, type: 'P', label: 'G3 · Peat. SW', position: [-3.1644095, 40.6300964], bearing: 270,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
    { id: 4, type: 'P', label: 'G4 · Peat. SE', position: [-3.1647474, 40.6301909], bearing: 90,
      phaseColors: { A: CC.H, B: CC.H, C: CC.P, D: CC.I } },
    // Central
    { id: 5, type: 'P', label: 'G5 · Peat. C', position: [-3.1648166, 40.6303261], bearing: 0,
      phaseColors: { A: CC.P, B: CC.I, C: CC.P, D: CC.I } },
  ],
  detectors: [],
  geometry: EMPTY_GEOMETRY,
};

// All simulated intersections
export const guadalajaraIntersections: IntersectionDefinition[] = [
  plazaMayor,
  avEjercito,
  glorietaBoixareu,
  calleDelTrabajo,
];

// Legacy export (backward compat)
export const guadalajaraIntersection = plazaMayor;
